import { CoreIconButton } from '@ingenico/react-ui/core-icon-button';
import { CoreTypography, CoreTypographyVariant } from '@ingenico/react-ui/core-typography';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import classNames from 'classnames';
import { isEmpty, toString } from 'lodash-es';
import type { ReactElement } from 'react';
import { useParams } from 'react-router';
import type { CallLogInformationProps } from './CallLogInformation.model';
import { CallLogInformationSeverity } from './CallLogInformation.model';
import styles from './CallLogInformation.module.scss';
import { exportCallLogs, parseLogError } from './CallLogInformation.util';

export function CallLogInformation({
  logLines,
  t,
  shouldHighlightSeverity = true,
}: CallLogInformationProps): ReactElement {
  const { callId } = useParams<{ callId: string }>();

  return (
    <div className={classNames(styles.callLogInformationContainer)}>
      <div className={classNames(styles.header)}>
        <div>
          <CoreTypography customClassName={classNames(styles.whiteFont)} variant={CoreTypographyVariant.Title03Medium}>
            {toString(t('cardTitle.callLogs'))}
          </CoreTypography>
        </div>
        <div>
          <CoreIconButton className={styles.exportButtonContainer} onClick={exportCallLogs(logLines, callId)}>
            <FileDownloadOutlinedIcon className={classNames(styles.whiteFont)} />
            <CoreTypography
              customClassName={classNames(styles.whiteFont)}
              variant={CoreTypographyVariant.Title03Medium}
            >
              {toString(t('common:button.export'))}
            </CoreTypography>
          </CoreIconButton>
        </div>
      </div>
      <div className={classNames(styles.logContainer)}>
        {isEmpty(logLines) ? (
          <CoreTypography customClassName={classNames(styles.whiteFont)} variant={CoreTypographyVariant.Title03Medium}>
            {toString(t('values.emptyLogs'))}
          </CoreTypography>
        ) : (
          logLines?.map(parseLogError(shouldHighlightSeverity)).map(({ prefix, message, severity }) => (
            <div className={classNames(styles.row)} key={`logLine_index_${prefix}_${severity}_${message}`}>
              <span className={styles.logMsgWrapper}>
                {prefix ? <span className={classNames(styles.whiteFont, styles.logMsg)}>{prefix}</span> : undefined}
                <span
                  className={classNames(styles.whiteFont, styles.logMsg, {
                    [styles?.warningLogMsg]: severity === CallLogInformationSeverity.Warning,
                    [styles?.errorLogMsg]: severity === CallLogInformationSeverity.Error,
                  })}
                >
                  {message}
                </span>
              </span>
            </div>
          ))
        )}
      </div>
    </div>
  );
}
